'use client'

import { useEffect } from 'react'
import { useStore } from '@/store'

export const CountryInitializer = ({
  country,
}: {
  country?: string | null
}) => {
  const setCountry = useStore(state => state.setCountry)

  useEffect(() => {
    if (country) {
      setCountry(country)
    }
  }, [country, setCountry])

  return null
}
